(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/betslip/betslip-content.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/betslip/betslip-content.js');

'use strict';

svs.maltipset.views.BetslipContent = Marionette.View.extend({
  className: 'maltipset-betslip-content',
  regions: {
    rows: '.rows',
    sportkryss: '.sportkryss',
    weeks: '.weeks'
  },
  template(data) {
    return svs.maltipset.templates.betslip_content(data);
  },
  onRender() {
    const self = this;
    this.getRegion('rows').show(new svs.maltipset.views.BetslipContentRows({
      model: new svs.maltipset.models.Betslip({
        coupon: this.options.coupon
      }),
      betslip: this.options.betslip
    }));
    this.getRegion('sportkryss').show(new svs.sport.sportkryss.Sportkryss({
      model: this.options.coupon.get('hasSportkryssBet') ? this.options.coupon.get('sportkryssBet') : null,
      onSportkryssChanged(bet) {
        self.options.coupon.updateSportkryss(bet);
      },
      toggleButtonCSSClass: 'sportkryss-btn-maltipset',
      helpDialogTitle: svs.maltipset.data.config.helpTexts.sportkryss.title,
      helpDialogBody: svs.maltipset.data.config.helpTexts.sportkryss.body
    }));
    this.getRegion('weeks').show(new svs.maltipset.views.BetslipContentWeeks({
      model: new svs.maltipset.models.Betslip({
        coupon: this.options.coupon
      })
    }));
    setTimeout(() => {
      self.options.betslip.changeSize();
    }, 0);
  }
});

 })(window);